import { render } from "./BookingsView.vue?vue&type=template&id=44b3e114"
import script from "./BookingsView.vue?vue&type=script&lang=js"
export * from "./BookingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__